import { Game } from "./game/Game";
import { applyVariantRuntime } from "./pwa/runtime";
import "./styles.css";

const canvas = document.querySelector("#game-canvas");
const ui = document.querySelector("#ui-root");
const hud = document.querySelector("#hud");
const rotate = document.querySelector("#rotate-gate");

if (!(canvas instanceof HTMLCanvasElement) || !(ui instanceof HTMLElement) || !(hud instanceof HTMLElement) || !(rotate instanceof HTMLElement)) {
  throw new Error("Structure HTML incomplète");
}

const game = new Game(canvas, ui, hud, rotate, localStorage);

applyVariantRuntime();

window.addEventListener("beforeunload", () => game.dispose());
